module.exports = __webpack_public_path__ + "img/empty-image.1412798e.svg";